import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { LOCATIONS } from "@/data/siteData";

export default function Locations() {
  return (
    <section id="lokalizacje" data-testid="locations-section" className="noise-blue text-[#F8FAFC] py-20 lg:py-28 slant-top slant-bottom">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <span className="font-accent uppercase tracking-[0.3em] text-[#FACC15] text-xs font-bold">05 — Lokalizacje</span>
        <h2 className="mt-4 font-display font-black uppercase tracking-tighter leading-none text-4xl sm:text-5xl">
          Trenujemy w <span className="text-[#FACC15]">4 miejscach</span> w Poznaniu
        </h2>
        <p className="mt-6 max-w-2xl text-blue-100 text-base font-medium">
          Wybierz najbliższą lokalizację i przyjdź na darmowy trening próbny.
        </p>

        <div className="mt-14 grid md:grid-cols-2 gap-6">
          {LOCATIONS.map((loc, i) => (
            <motion.article
              key={loc.id}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.45, delay: i * 0.07 }}
              data-testid={`location-card-${loc.id}`}
              className="border-2 border-blue-400 bg-blue-600/40 hover:border-[#FACC15] transition-colors duration-200"
            >
              <div className="h-56 w-full">
                <iframe
                  title={`Mapa — ${loc.name}`}
                  data-testid={`location-map-${loc.id}`}
                  src={loc.map}
                  className="w-full h-full border-0"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
              <div className="p-6">
                <div className="flex items-start gap-3">
                  <MapPin className="text-[#FACC15] shrink-0 mt-1" size={20} />
                  <div>
                    <h3 className="font-display font-black uppercase tracking-tight text-xl">{loc.name}</h3>
                    <p className="font-accent text-sm font-bold text-blue-100 mt-1">{loc.address}</p>
                    <p className="text-sm text-blue-200 font-medium mt-2">{loc.note}</p>
                  </div>
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
